module.exports = __webpack_public_path__ + "assets/img/8.f3e6ab18.png";